import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './metaCombustivelTermoUsoForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';

import { 
	setModoTela, initForm, salvar, excluir, getLista, setFiltro, getDownload, getListaAceites
} from './metaCombustivelTermoUsoActions';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import consts from '../consts';
import { event } from 'jquery';

class MetaCombustivelTermoUso extends Component {

	state = {
		linhaSelecionada: null,
		ordenacao: {
			datahora_inclusao: 1
		}
	}

    componentWillMount() {

		this.props.setModoTela('lista');

        this.props.getLista();
    }

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown);
	}
	
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyDown);
	}
	
	handleKeyDown = (e) => {
		if (e.key === 'Escape') {
			this.setState({
				...this.state,
				registroAceites: null 
			});
		}
	};

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form tratativa onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form tratativa excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	getIcon(type) {
		switch (type) {
			case "pdf":
				return "fa-file-pdf";
			case "doc":
			case "docx":
				return "fa-file-word";
			case "xls":
			case "xlsx":
				return "fa-file-excel";
			case "ppt":
			case "pptx":
				return "fa-file-powerpoint";
			case "png":
			case "jpg":
			case "jpeg":
				return "fa-file-image";
			case "txt":
				return "fa-file-lines";
			case "xml":
				return "fa-file-code";
			default:
				return "fa-file";
		}
	};

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {			
			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;			
		}).filter(item => {
			if (!this.props.usuarioCarregado) {
				return false;
			}
			
			return true;
		});		

		if (this.state.ordenacao.datahora_inclusao) {
			lista.sort((a, b) => this.state.ordenacao.datahora_inclusao == 1 
				? (a.datahora_inclusao > b.datahora_inclusao ? 1 : -1) 
				: (a.datahora_inclusao > b.datahora_inclusao ? -1 : 1));
		} 

		return (
			<ContentCard>

				{this.modalAceites()}

				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />
						
						<div style={{ width: 310, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {									
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {
										id_tipo: 1
									});
									this.props.initForm({ 
										id_tipo: 1
									});
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>

						</div>
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 190}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 190}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)
						}}>
						<Table responsive border striped alturaFixa 
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 190}px`
								: (
									window.innerWidth < 1799 
									? `${window.innerHeight - 190}px`
									: (
										window.innerWidth < 4000 
										? `${window.innerHeight - 190}px`
										: `${window.innerHeight - 190}px`
									)
								)
							)}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} 
										onClick={() => this.setState({ ...this.state, ordenacao: { datahora_inclusao: this.getNovaOrdenacao(this.state.ordenacao.datahora_inclusao) }})} 
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Data/Hora {this.getIconeOrdenacao(this.state.ordenacao.datahora_inclusao)}</Th>
									<Th paddingTop={2} paddingBottom={2} 
										title='Arquivo'
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Arquivo</Th>
									<Th paddingTop={2} paddingBottom={2} 
										title='Aceites'
										sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Aceites</Th>
									<Th paddingTop={2} paddingBottom={2} 
										sticky width={50} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter title='Ações'></Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map((item, i) => (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td minWidth={100} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
										<Td minWidth={100} color={'#000'} alignCenter small>
											<button
												onClick={() => {
													this.props.getDownload(item.id);
												}}
												style={{
													border: 'none',
													background: 'transparent',
													cursor: 'pointer',
													fontSize: 16,
													marginLeft: 4
												}} >
												<i className='fas fa-download'></i>
											</button>
										</Td>
										<Td minWidth={50} alignCenter>										
											<ButtonTable
												type={'primary'}
												icon={'fas fa-tasks'}
												visible={true}
												small
												event={(event) => {
													event.stopPropagation();
													if (!item.quantidade_aceites) {
														window.alert('Nenhum usuário aceitou os termos de uso.');
													} else {
														this.setState({
															...this.state,
															registroAceites: {
																...item
															}
														});
														
														this.props.getListaAceites(item.id);
													}
												}} />
										</Td>
										<Td minWidth={50} alignCenter>										
											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={true}
												small
												event={() => {
													if (item.quantidade_aceites > 0) {
														window.alert('Não é possível excluir! Já existem usuários que aceitaram esse termo de uso.');
													} else {
														this.props.excluir({
															...item
														});
													}
												}} />
										</Td>
									</Tr>
								))}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalAceites() {
	
			if (!this.state.registroAceites) {
				return null;
			}
		
			return (
				<>
					<div className="modal-backdrop fade show" onClick={this.handleBackdropClick} />
	
					<div class='modal fade show' id='modal-md'
						style={{
							display: 'block'
						}} 
						aria-modal='true'
						onClick={this.handleBackdropClick} >
						<div class='modal-dialog'
							style={{ maxWidth: '95vw', margin: '1.75rem auto' }}
							onClick={this.handleModalClick}>
							<div class='modal-content'>
								<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
									<h4 class='modal-title'>Termo de uso {DateFormat.formatarDataHoraSqlParaTela(this.state.registroAceites.datahora_inclusao)}</h4>
									<button type='button' class='close custom-close' data-dismiss='modal' aria-label='Close' 
										onClick={() => {
											this.setState({
												...this.state,
												registroAceites: null
											});
										}}>
										<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
									</button>
								</div>
								<div class='modal-body'
									style={{									
										overflowY: 'scroll',
										backgroundColor: '#1F3066',
										paddingLeft: 8,
										paddingRight: 8,
										paddingTop: 8,
										marginBottom: 0,
										minHeight: 400
									}}>
									<Table  responsive border striped alturaFixa 
										maxHeight={window.innerHeight * 0.8}>
										<THead>
											<Tr backgroundColor={'#1F3066'}
												color={'#ffffff'}
												height={47}>
												<Th paddingTop={2} paddingBottom={2} 
													sticky width={100} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Data/Hora</Th>
												<Th paddingTop={2} paddingBottom={2} 
													sticky width={200} backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Usuário</Th>
											</Tr>
										</THead>
										<TBody>
											{this.props.listaAceites.map((item, i) => (
												<Tr key={item.id}
													backgroundColor={this.state.linhaSelecionadaModal == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
													onClick={() => this.setState({ ...this.state, linhaSelecionadaModal: item.id })} >
													<Td  minWidth={100} color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_aceite)}</Td>
													<Td  minWidth={200} color={'#000'} alignCenter small>{item.nome_usuario}</Td>
												</Tr>
											))}
										</TBody>
									</Table>
	
								</div>
							</div>
						</div>
					</div>
				</>
			);
		}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.metaCombustivelTermoUso.aguardando,
	modoTela: state.metaCombustivelTermoUso.modoTela,
	lista: state.metaCombustivelTermoUso.lista,
	filtro: state.metaCombustivelTermoUso.filtro,
	listaAceites: state.metaCombustivelTermoUso.listaAceites
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista, setFiltro, getDownload, getListaAceites
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MetaCombustivelTermoUso);
